/**
 * @generated SignedSource<<51db2945011148e7fcd4e9af07a51299>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNavigationItemTypeKey = "APP" | "APPROVALS" | "APPS" | "ARCHIVED_ISSUES" | "ATTACHMENTS" | "BACKLOG" | "BOARD" | "CALENDAR" | "CODE" | "COMPONENTS" | "CUSTOMER_SUPPORT" | "DEPENDENCIES" | "DEPLOYMENTS" | "DEVELOPMENT" | "FORMS" | "GET_STARTED" | "GOALS" | "INBOX" | "INCIDENTS" | "ISSUES" | "LIST" | "ON_CALL" | "PAGES" | "PLAN_CALENDAR" | "PLAN_DEPENDENCIES" | "PLAN_PROGRAM" | "PLAN_RELEASES" | "PLAN_SUMMARY" | "PLAN_TEAMS" | "PLAN_TIMELINE" | "PROGRAM" | "QUEUE" | "RELEASES" | "REPORTS" | "REQUESTS" | "SECURITY" | "SHORTCUTS" | "STAFFING" | "SUMMARY" | "TEAMS" | "TIMELINE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ContainerNavigationTabs_container$data = {
  readonly canEdit?: boolean;
  readonly id?: string;
  readonly navigationItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __id: string;
        readonly appId?: string | null | undefined;
        readonly id: string;
        readonly label: string | null | undefined;
        readonly sections?: ReadonlyArray<{
          readonly links: ReadonlyArray<{
            readonly url: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined> | null | undefined;
        readonly typeKey: JiraNavigationItemTypeKey | null | undefined;
        readonly url: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"NavigationItemTab_tab">;
      };
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly scopeId?: string | null | undefined;
  readonly scopeUrl?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AddTab_container" | "NavigationItemTab_container">;
  readonly " $fragmentType": "ContainerNavigationTabs_container";
};
export type ContainerNavigationTabs_container$key = {
  readonly " $data"?: ContainerNavigationTabs_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContainerNavigationTabs_container">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "ContainerNavigationTabs_container",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "NavigationItemTab_container"
    },
    {
      "kind": "FragmentSpread",
      "name": "AddTab_container"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "RequiredField",
          "field": (v0/*: any*/),
          "action": "THROW",
          "path": "id"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "canEdit"
          },
          "action": "THROW",
          "path": "canEdit"
        },
        {
          "kind": "ScalarField",
          "name": "scopeUrl"
        },
        {
          "kind": "ScalarField",
          "name": "scopeId"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            }
          ],
          "concreteType": "JiraNavigationItemConnection",
          "kind": "LinkedField",
          "name": "navigationItems",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraNavigationItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v0/*: any*/),
                        "action": "THROW",
                        "path": "navigationItems.edges.node.id"
                      },
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "typeKey"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "label"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "appId"
                          },
                          {
                            "concreteType": "JiraAppSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraAppNavigationItemNestedLink",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": true,
                                "selections": [
                                  (v1/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraAppNavigationItem"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "NavigationItemTab_tab"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "navigationItems.edges.node"
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraContainerNavigation"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};
})();

(node as any).hash = "109e1b7e3cf26fe989509a4a6ab41afc";

export default node;
